function getInfomation(_this, username) {
  let customer = {};
  customer.username = username;

  _this.$axios({
    method: 'post',
    // url: Vue.prototype.api + '6003/api/local/selectInfomation',
    url: Vue.prototype.api + 'api/local/selectInfomation',
    data: customer
  }).then((response) => {
    if (response.status == 200) {
      if (response.data.code == '200') {
        _this.formData.basicInfo.email = response.data.data.user.email;

        if (response.data.data.user.ccemailList != null) {
          if (response.data.data.user.ccemailList.length > 0) {
            if (response.data.data.user.ccemailList.length == 1) {
              _this.formData.basicInfo.cc_email.email1 = response.data.data.user.ccemailList[0];
            } else if (response.data.data.user.ccemailList.length == 2) {
              _this.formData.basicInfo.cc_email.email1 = response.data.data.user.ccemailList[0];
              _this.formData.basicInfo.cc_email.email2 = response.data.data.user.ccemailList[1];
            } else if (response.data.data.user.ccemailList.length == 3) {
              _this.formData.basicInfo.cc_email.email1 = response.data.data.user.ccemailList[0];
              _this.formData.basicInfo.cc_email.email2 = response.data.data.user.ccemailList[1];
              _this.formData.basicInfo.cc_email.email3 = response.data.data.user.ccemailList[2];
            } else if (response.data.data.user.ccemailList.length == 4) {
              _this.formData.basicInfo.cc_email.email1 = response.data.data.user.ccemailList[0];
              _this.formData.basicInfo.cc_email.email2 = response.data.data.user.ccemailList[1];
              _this.formData.basicInfo.cc_email.email3 = response.data.data.user.ccemailList[2];
              _this.formData.basicInfo.cc_email.email4 = response.data.data.user.ccemailList[3];
            } else if (response.data.data.user.ccemailList.length == 5) {
              _this.formData.basicInfo.cc_email.email1 = response.data.data.user.ccemailList[0];
              _this.formData.basicInfo.cc_email.email2 = response.data.data.user.ccemailList[1];
              _this.formData.basicInfo.cc_email.email3 = response.data.data.user.ccemailList[2];
              _this.formData.basicInfo.cc_email.email4 = response.data.data.user.ccemailList[3];
              _this.formData.basicInfo.cc_email.email5 = response.data.data.user.ccemailList[4];
            }
          }
        }

        _this.pageData.oldBasicInfo = JSON.parse(JSON.stringify(_this.formData.basicInfo));
        return;
      } else if (response.data.code == '210') {
        _this.$notify.error({
          title: _this.$t("App.notify.title_server"),
          message: _this.$t("App.notify.content_entitiesept")
        });
        return;
      } else {

        _this.$notify.error({
          title: _this.$t("App.notify.title_server"),
          message: _this.$t("App.notify.content_servererr")
        });
        return;
      }
    } else {
      _this.$notify.error({
        title: _this.$t("App.notify.title_server"),
        message: _this.$t("App.notify.content_server") + response.status
      });
      return;
    }
  }).catch((error) => {
    _this.$notify.error({
      title: _this.$t("App.notify.title_server"),
      message: _this.$t("App.notify.content_servererr")
    });
    return;
  });
}

function getAllOrders(_this, username) {
  _this.$axios({
    method: 'post',
    // url: Vue.prototype.api + '6003/api/local/getAllOrders',
    url: Vue.prototype.api + 'api/local/getAllOrders',
    data: {
      username
    }
  }).then((response) => {
    if (response.status == 200) {
      if (response.data.code == '200') {
        _this.pageData.listOrders = response.data.data;
        _this.pageData.listOrdersBackup = response.data.data;
        for (let order of response.data.data) {
          if (order.orderstatus_id == 'OT0000000007') {
            _this.pageData.listOrders_finished.push(order);
          } else {
            _this.pageData.listOrders_processing.push(order);
          }
        }
        return;
      } else if (response.data.code == '210') {

        return;
      } else {

        _this.$notify.error({
          title: _this.$t("App.notify.title_server"),
          message: _this.$t("App.notify.content_servererr")
        });
        return;
      }
    } else {
      _this.$notify.error({
        title: _this.$t("App.notify.title_server"),
        message: _this.$t("App.notify.content_server") + response.status
      });
      return;
    }
  }).catch((error) => {
    _this.$notify.error({
      title: _this.$t("App.notify.title_server"),
      message: _this.$t("App.notify.content_servererr")
    });
    return;
  });
}

function getAllShipping(_this, username) {
  _this.pageData.shippingList = [];
  let customer = {};
  customer.username = username;

  _this.$axios({
    method: 'post',
    // url: Vue.prototype.api + '6003/api/local/selectShippingAddressByUsername',
    url: Vue.prototype.api + 'api/local/selectShippingAddressByUsername',
    data: customer
  }).then((response) => {
    if (response.status == 200) {
      if (response.data.code == '200') {

        _this.pageData.shippingList = response.data.data;

        return;
      } else if (response.data.code == '210') {

        return;
      } else {

        _this.$notify.error({
          title: _this.$t("App.notify.title_server"),
          message: _this.$t("App.notify.content_servererr")
        });
        return;
      }
    } else {
      _this.$notify.error({
        title: _this.$t("App.notify.title_server"),
        message: _this.$t("App.notify.content_server") + response.status
      });
      return;
    }
  }).catch((error) => {
    _this.$notify.error({
      title: _this.$t("App.notify.title_server"),
      message: _this.$t("App.notify.content_servererr")
    });
    return;
  });
}

function getAllReceipt(_this, username) {
  _this.pageData.receiptList = [];
  let customer = {};
  customer.username = username;

  _this.$axios({
    method: 'post',
    // url: Vue.prototype.api + '6003/api/local/selectReceiptAddressByUsername',
    url: Vue.prototype.api + 'api/local/selectReceiptAddressByUsername',
    data: customer
  }).then((response) => {
    if (response.status == 200) {
      if (response.data.code == '200') {

        _this.pageData.receiptList = response.data.data;

        return;
      } else if (response.data.code == '210') {

        return;
      } else {

        _this.$notify.error({
          title: _this.$t("App.notify.title_server"),
          message: _this.$t("App.notify.content_servererr")
        });
        return;
      }
    } else {
      _this.$notify.error({
        title: _this.$t("App.notify.title_server"),
        message: _this.$t("App.notify.content_server") + response.status
      });
      return;
    }
  }).catch((error) => {
    _this.$notify.error({
      title: _this.$t("App.notify.title_server"),
      message: _this.$t("App.notify.content_servererr")
    });
    return;
  });
}

function deleteShipping(_this, shippingid) {
  let shipping = {};
  shipping.id = shippingid;

  _this.$confirm(_this.$t("App.page.center.text_delete_message_body"), _this.$t("App.page.center.text_delete_message_title"), {
    confirmButtonText: _this.$t("App.page.center.btn_message_confirm"),
    cancelButtonText: _this.$t("App.page.center.btn_message_cancel"),
    iconClass: 'el-icon-question'
  }).then(() => {
    _this.$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/deleteShippingAddressById',
      url: Vue.prototype.api + 'api/local/deleteShippingAddressById',
      data: shipping
    }).then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          for (let index in _this.pageData.shippingList) {
            if (_this.pageData.shippingList[index].id === shipping.id) {
              _this.pageData.shippingList.splice(index, 1);
            }
          }
          _this.$message.success(_this.$t("App.page.center.delete_address_success"));
          return;
        } else {

          _this.$notify.error({
            title: _this.$t("App.notify.title_server"),
            message: _this.$t("App.notify.content_servererr")
          });
          return;
        }
      } else {
        _this.$notify.error({
          title: _this.$t("App.notify.title_server"),
          message: _this.$t("App.notify.content_server") + response.status
        });
        return;
      }
    }).catch((error) => {
      _this.$notify.error({
        title: _this.$t("App.notify.title_server"),
        message: _this.$t("App.notify.content_servererr")
      });
      return;
    });
  }).catch(() => {
    _this.$message({
      type: 'info',
      message: _this.$t("App.page.center.message_cancel")
    });
  });
}

function deleteReceipt(_this, receiptid) {
  let receipt = {};
  receipt.id = receiptid;

  _this.$confirm(_this.$t("App.page.center.text_delete_message_body"), _this.$t("App.page.center.text_delete_message_title"), {
    confirmButtonText: _this.$t("App.page.center.btn_message_confirm"),
    cancelButtonText: _this.$t("App.page.center.btn_message_cancel"),
    iconClass: 'el-icon-question'
  }).then(() => {
    _this.$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/deleteReceiptAddressById',
      url: Vue.prototype.api + 'api/local/deleteReceiptAddressById',
      data: receipt
    }).then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          for (let index in _this.pageData.receiptList) {
            if (_this.pageData.receiptList[index].id === receipt.id) {
              _this.pageData.receiptList.splice(index, 1);
            }
          }
          _this.$message.success(_this.$t("App.page.center.delete_address_success"));
          return;
        } else {

          _this.$notify.error({
            title: _this.$t("App.notify.title_server"),
            message: _this.$t("App.notify.content_servererr")
          });
          return;
        }
      } else {
        _this.$notify.error({
          title: _this.$t("App.notify.title_server"),
          message: _this.$t("App.notify.content_server") + response.status
        });
        return;
      }
    }).catch((error) => {
      _this.$notify.error({
        title: _this.$t("App.notify.title_server"),
        message: _this.$t("App.notify.content_servererr")
      });
      return;
    });
  }).catch(() => {
    _this.$message({
      type: 'info',
      message: _this.$t("App.page.center.message_cancel")
    });
  });
}

function doNewShipping(_this, shipping) {
  if (verifyjs.strIsEmpty(shipping.country) ||
    verifyjs.strIsEmpty(shipping.province) ||
    verifyjs.strIsEmpty(shipping.city) ||
    verifyjs.strIsEmpty(shipping.zipcode) ||
    verifyjs.strIsEmpty(shipping.address) ||
    verifyjs.strIsEmpty(shipping.company) ||
    verifyjs.strIsEmpty(shipping.contacts) ||
    verifyjs.strIsEmpty(shipping.tel) ||
    verifyjs.strIsEmpty(shipping.email) ||
    verifyjs.strIsEmpty(shipping.tag)) {
    _this.$notify.error({
      title: _this.$t("App.page.center.notify_normal_err_code"),
      message: _this.$t("App.page.center.notify_address_null")
    });
    return;
  }

  let regEmail = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,10}$/;
  if (!(regEmail.test(shipping.email))) {
    _this.$notify.error({
      title: _this.$t("App.page.center.notify_normal_err_code"),
      message: _this.$t("App.page.center.notify_email_error")
    });
    return;
  }

  shipping.username = _this.pageData.username;
  _this.$axios({
    method: 'post',
    // url: Vue.prototype.api + '6003/api/local/addShipping',
    url: Vue.prototype.api + 'api/local/addShipping',
    data: shipping
  }).then((response) => {
    if (response.status == 200) {
      if (response.data.code == '200') {
        _this.pageData.addShippingDialogVisible = false;
        _this.$message({
          message: _this.$t('App.page.center.message_success'),
          type: 'success'
        });

        return;
      } else if (response.data.code == '290') {
        _this.$notify.error({
          title: _this.$t("App.page.center.notify_warn"),
          message: _this.$t("App.page.center.notify_full_address_java")
        });
        return;
      } else {

        _this.$notify.error({
          title: _this.$t("App.notify.title_server"),
          message: _this.$t("App.notify.content_servererr")
        });
        return;
      }
    } else {
      _this.$notify.error({
        title: _this.$t("App.notify.title_server"),
        message: _this.$t("App.notify.content_server") + response.status
      });
      return;
    }
  }).catch((error) => {
    _this.$notify.error({
      title: _this.$t("App.notify.title_server"),
      message: _this.$t("App.notify.content_servererr")
    });
    return;
  });
}

function doNewReceipt(_this, receipt) {
  if (verifyjs.strIsEmpty(receipt.country) ||
    verifyjs.strIsEmpty(receipt.province) ||
    verifyjs.strIsEmpty(receipt.city) ||
    verifyjs.strIsEmpty(receipt.zipcode) ||
    verifyjs.strIsEmpty(receipt.address) ||
    verifyjs.strIsEmpty(receipt.company) ||
    verifyjs.strIsEmpty(receipt.contacts) ||
    verifyjs.strIsEmpty(receipt.tel) ||
    verifyjs.strIsEmpty(receipt.email) ||
    verifyjs.strIsEmpty(receipt.tag)) {
    _this.$notify.error({
      title: _this.$t("App.page.center.notify_normal_err_code"),
      message: _this.$t("App.page.center.notify_address_null")
    });
    return;
  }

  if (verifyjs.strIsEmpty(receipt.taxno)) {
    receipt.taxno = '-';
  }

  let regEmail = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,10}$/;
  if (!(regEmail.test(receipt.email))) {
    _this.$notify.error({
      title: _this.$t("App.page.center.notify_normal_err_code"),
      message: _this.$t("App.page.center.notify_email_error")
    });
    return;
  }

  receipt.username = _this.pageData.username;
  _this.$axios({
    method: 'post',
    // url: Vue.prototype.api + '6003/api/local/addReceipt',
    url: Vue.prototype.api + 'api/local/addReceipt',
    data: receipt
  }).then((response) => {
    if (response.status == 200) {
      if (response.data.code == '200') {
        _this.pageData.addReceiptDialogVisible = false;
        _this.$message({
          message: _this.$t('App.page.center.message_success'),
          type: 'success'
        });

        return;
      } else if (response.data.code == '290') {
        _this.$notify.error({
          title: _this.$t("App.page.center.notify_warn"),
          message: _this.$t("App.page.center.notify_full_address_java")
        });
        return;
      } else {

        _this.$notify.error({
          title: _this.$t("App.notify.title_server"),
          message: _this.$t("App.notify.content_servererr")
        });
        return;
      }
    } else {
      _this.$notify.error({
        title: _this.$t("App.notify.title_server"),
        message: _this.$t("App.notify.content_server") + response.status
      });
      return;
    }
  }).catch((error) => {
    _this.$notify.error({
      title: _this.$t("App.notify.title_server"),
      message: _this.$t("App.notify.content_servererr")
    });
    return;
  });
}

function doEditShipping(_this, shipping) {
  return new Promise((resolve, reject) => {
    _this.pageData.doEditShippingLoad = true;

    if (shipping.country !== _this.pageData.oldShipping.country ||
      shipping.province !== _this.pageData.oldShipping.province ||
      shipping.city !== _this.pageData.oldShipping.city ||
      shipping.zipcode !== _this.pageData.oldShipping.zipcode ||
      shipping.address !== _this.pageData.oldShipping.address ||
      shipping.company !== _this.pageData.oldShipping.company ||
      shipping.contacts !== _this.pageData.oldShipping.contacts ||
      shipping.tel !== _this.pageData.oldShipping.tel ||
      shipping.email !== _this.pageData.oldShipping.email ||
      shipping.tag !== _this.pageData.oldShipping.tag
    ) {
      if (verifyjs.strIsEmpty(shipping.country) ||
        verifyjs.strIsEmpty(shipping.province) ||
        verifyjs.strIsEmpty(shipping.city) ||
        verifyjs.strIsEmpty(shipping.zipcode) ||
        verifyjs.strIsEmpty(shipping.address) ||
        verifyjs.strIsEmpty(shipping.company) ||
        verifyjs.strIsEmpty(shipping.contacts) ||
        verifyjs.strIsEmpty(shipping.tel) ||
        verifyjs.strIsEmpty(shipping.email) ||
        verifyjs.strIsEmpty(shipping.tag)
      ) {
        _this.pageData.doEditShippingLoad = false;
        _this.$notify.error({
          title: _this.$t("App.page.center.notify_normal_err_code"),
          message: _this.$t("App.page.center.notify_address_null")
        });
        return;
      }

      let regEmail = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,10}$/;
      if (!(regEmail.test(shipping.email))) {
        _this.$notify.error({
          title: _this.$t("App.page.center.notify_normal_err_code"),
          message: _this.$t("App.page.center.notify_email_error")
        });
        _this.pageData.doEditShippingLoad = false;
        return;
      }

      updateShipping(_this, shipping).then((val) => {
        resolve(val);
      });
    } else {

      _this.pageData.doEditShippingLoad = false;
      _this.pageData.editShippingDialogVisible = false;
    }
  });
}

function doEditReceipt(_this, receipt) {
  return new Promise((resolve, reject) => {
    _this.pageData.doEditReceiptLoad = true;

    if (receipt.country !== _this.pageData.oldReceipt.country ||
      receipt.province !== _this.pageData.oldReceipt.province ||
      receipt.city !== _this.pageData.oldReceipt.city ||
      receipt.zipcode !== _this.pageData.oldReceipt.zipcode ||
      receipt.address !== _this.pageData.oldReceipt.address ||
      receipt.company !== _this.pageData.oldReceipt.company ||
      receipt.contacts !== _this.pageData.oldReceipt.contacts ||
      receipt.tel !== _this.pageData.oldReceipt.tel ||
      receipt.email !== _this.pageData.oldReceipt.email ||
      receipt.taxno !== _this.pageData.oldReceipt.taxno ||
      receipt.tag !== _this.pageData.oldReceipt.tag
    ) {
      if (verifyjs.strIsEmpty(receipt.country) ||
        verifyjs.strIsEmpty(receipt.province) ||
        verifyjs.strIsEmpty(receipt.city) ||
        verifyjs.strIsEmpty(receipt.zipcode) ||
        verifyjs.strIsEmpty(receipt.address) ||
        verifyjs.strIsEmpty(receipt.company) ||
        verifyjs.strIsEmpty(receipt.contacts) ||
        verifyjs.strIsEmpty(receipt.tel) ||
        verifyjs.strIsEmpty(receipt.email) ||
        verifyjs.strIsEmpty(receipt.tag)
      ) {
        _this.pageData.doEditReceiptLoad = false;
        _this.$notify.error({
          title: _this.$t("App.page.center.notify_normal_err_code"),
          message: _this.$t("App.page.center.notify_address_null")
        });
        return;
      }

      let regEmail = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,10}$/;
      if (!(regEmail.test(receipt.email))) {
        _this.$notify.error({
          title: _this.$t("App.page.center.notify_normal_err_code"),
          message: _this.$t("App.page.center.notify_email_error")
        });
        _this.pageData.doEditReceiptLoad = false;
        return;
      }

      if (verifyjs.strIsEmpty(receipt.taxno)) {
        receipt.taxno = '-';
      }

      updateReceipt(_this, receipt).then((val) => {
        resolve(val);
      });
    } else {

      _this.pageData.doEditReceiptLoad = false;
      _this.pageData.editReceiptDialogVisible = false;
    }
  });
}

function updateShipping(_this, shipping) {
  return new Promise((resolve, reject) => {
    _this.$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/updateShippingById',
      url: Vue.prototype.api + 'api/local/updateShippingById',
      data: shipping
    }).then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          _this.pageData.doEditShippingLoad = false;
          _this.pageData.editShippingDialogVisible = false;
          _this.$message({
            message: _this.$t('App.page.center.message_success'),
            type: 'success'
          });

          resolve(true);
        } else {

          _this.$notify.error({
            title: _this.$t("App.notify.title_server"),
            message: _this.$t("App.notify.content_servererr")
          });
          return;
        }
      } else {
        _this.$notify.error({
          title: _this.$t("App.notify.title_server"),
          message: _this.$t("App.notify.content_server") + response.status
        });
        return;
      }
    }).catch((error) => {
      _this.$notify.error({
        title: _this.$t("App.notify.title_server"),
        message: _this.$t("App.notify.content_servererr")
      });
      return;
    });
  });
}

function updateReceipt(_this, receipt) {
  return new Promise((resolve, reject) => {
    _this.$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/updateReceiptById',
      url: Vue.prototype.api + 'api/local/updateReceiptById',
      data: receipt
    }).then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          _this.pageData.doEditReceiptLoad = false;
          _this.pageData.editReceiptDialogVisible = false;
          _this.$message({
            message: _this.$t('App.page.center.message_success'),
            type: 'success'
          });

          resolve(true);
        } else {

          _this.$notify.error({
            title: _this.$t("App.notify.title_server"),
            message: _this.$t("App.notify.content_servererr")
          });
          return;
        }
      } else {
        _this.$notify.error({
          title: _this.$t("App.notify.title_server"),
          message: _this.$t("App.notify.content_server") + response.status
        });
        return;
      }
    }).catch((error) => {
      _this.$notify.error({
        title: _this.$t("App.notify.title_server"),
        message: _this.$t("App.notify.content_servererr")
      });
      return;
    });
  });
}

function doResetPass(_this, password) {
  if (verifyjs.strIsEmpty(password) || password.length < 3 || password.length > 15) {
    _this.$notify.error({
      title: _this.$t("App.page.center.notify_normal_err_code"),
      message: _this.$t("App.page.center.notify_password_length")
    });
    return;
  }

  updatePassword(_this, password);

}

function doModifyBasic(_this, basicinfo) {
  if (verifyjs.strIsEmpty(basicinfo.email)) {
    _this.$notify.error({
      title: _this.$t("App.page.center.notify_normal_err_code"),
      message: _this.$t("App.page.center.notify_address_null")
    });
    return;
  }

  let regEmail = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,10}$/;
  if (!(regEmail.test(basicinfo.email))) {
    _this.$notify.error({
      title: _this.$t("App.page.center.notify_normal_err_code"),
      message: _this.$t("App.page.center.notify_email_error")
    });
    return;
  }

  let emailList = [];
  for (let key in basicinfo.cc_email) {
    if (!(verifyjs.strIsEmpty(basicinfo.cc_email[key])) && regEmail.test(basicinfo.cc_email[key])) {
      emailList.push(basicinfo.cc_email[key]);
    }
  }
  basicinfo.ccemailList = emailList;

  updateBasic(_this, basicinfo);

}

function updatePassword(_this, password) {
  let user = {};
  user.username = _this.pageData.username;
  user.password = password;

  _this.$axios({
    method: 'post',
    // url: Vue.prototype.api + '6003/api/local/resetPassword',
    url: Vue.prototype.api + 'api/local/resetPassword',
    data: user
  }).then((response) => {
    if (response.status == 200) {
      if (response.data.code == '200') {
        _this.$message({
          message: _this.$t('App.page.center.message_resetpasssuccess'),
          type: 'success'
        });
        _this.pageData.resetPasswordDialogVisible = false;
        setTimeout(() => {
          _this.$router.push({
            name: 'Login'
          });
        }, 3000);

        return;
      } else {

        _this.$notify.error({
          title: _this.$t("App.notify.title_server"),
          message: _this.$t("App.notify.content_servererr")
        });
        return;
      }
    } else {
      _this.$notify.error({
        title: _this.$t("App.notify.title_server"),
        message: _this.$t("App.notify.content_server") + response.status
      });
      return;
    }
  }).catch((error) => {
    _this.$notify.error({
      title: _this.$t("App.notify.title_server"),
      message: _this.$t("App.notify.content_servererr")
    });
    return;
  });
}

function updateBasic(_this, basicinfo) {
  basicinfo.username = _this.pageData.username;

  _this.$axios({
    method: 'post',
    // url: Vue.prototype.api + '6003/api/local/modifyBasicInUser',
    url: Vue.prototype.api + 'api/local/modifyBasicInUser',
    data: basicinfo
  }).then((response) => {
    if (response.status == 200) {
      if (response.data.code == '200') {
        _this.$message({
          message: _this.$t('App.page.center.message_success'),
          type: 'success'
        });

        return;
      } else if (response.data.code == '290') {
        this.$notify.warning({
          title: _this.$t("App.notify.title_warning"),
          message: _this.$t("App.notify.content_redundancy")
        });

        return;
      } else {

        _this.$notify.error({
          title: _this.$t("App.notify.title_server"),
          message: _this.$t("App.notify.content_servererr")
        });
        return;
      }
    } else {
      _this.$notify.error({
        title: _this.$t("App.notify.title_server"),
        message: _this.$t("App.notify.content_server") + response.status
      });
      return;
    }
  }).catch((error) => {
    _this.$notify.error({
      title: _this.$t("App.notify.title_server"),
      message: _this.$t("App.notify.content_servererr")
    });
    return;
  });
}

import Vue from 'vue';
import * as verifyjs from "@/assets/js/verify";

export {
  getInfomation,
  getAllOrders,
  getAllShipping,
  getAllReceipt,
  deleteShipping,
  deleteReceipt,
  doNewShipping,
  doNewReceipt,
  doEditShipping,
  doEditReceipt,
  doResetPass,
  doModifyBasic
}



// WEBPACK FOOTER //
// ./src/assets/js/center.js